export function formatOccurrenceStatus(
  status: string = 'aguardando', 
  waitingPolicemanResponse = false
) {
  switch (status) {
    case "aguardando": 
      return "Em aberto";
    case "associado":
      return "Aguardando PR";
    case "aprovacao-km-inicial":
      return waitingPolicemanResponse ? "Esperando reenvio" : "Pra validar";
    case "aprovacao":
      return "Pra validar";
    case "andamento":
      return "Em andamento";
    case "semi-concluido":
      return "Em andamento"
    case "aprovacao-km-final":
      return waitingPolicemanResponse ? "Esperando reenvio" : "Pra validar";
    case "concluido":
      return "Finalizado";
    case "aguardando_cancelamento":
      return 'Aguardando cancelamento';
    default: 
      return "Em aberto";
  }
}